module.exports = __webpack_public_path__ + "images/emoji/candy.c5df7c388337b5427759.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/candy.png
// module id = CnbF
// module chunks = 13